import React,{Component} from "react";
import { connect } from "react-redux";
import { Alert, Modal, ModalHeader,ModalBody } from 'reactstrap';
import Form from "./Form";
import Actions from "../../../Actions";
import Tile from "../Layout/Tile";

class LocationAdd extends Component{
    constructor(props){
        super(props);
        this.alertRef = false;
    }

    componentDidUpdate(){
        const {locationStore: { alert: { add } } } = this.props;
        if(add && this.modalRef ) this.modalRef.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
    }

    render = () => {
        const { locationStore: { alert: { add } }, locationModal: { add: { modal }}, toggleModal } = this.props;
        const { addLocation } = this.props;
        return (
            <div>
                <Modal size="lg" isOpen={modal} keyboard={false} toggle={() => toggleModal("locations","add")}>
                    <ModalHeader toggle={() => toggleModal("locations","add")}>Add Location</ModalHeader>
                    <ModalBody style={{backgroundColor:"#f2f2f2"}}>
                        <div ref={(ref) => this.modalRef = ref}>
                            <Tile xs="11" style={{marginTop:15,paddingTop:15,backgroundColor:"#fff"}} className="shadow-sm rounded mx-auto">
                                {add !== false &&
                                    <Alert color={add.type}>
                                        { add.message }
                                    </Alert>                                         
                                }
                                <Form data='' persist={addLocation} />
                            </Tile>
                        </div>
                    </ModalBody>
                </Modal>
            </div>                            
        );
    }
}

const mapStateToProps = (state) => ({
    locationStore: state.locationStore,
    locationModal: state.modalStore.locations,
    
});

const { locations, modals } = Actions;

export default connect(mapStateToProps, { ...locations, ...modals })(LocationAdd);


// WEBPACK FOOTER //
// ./src/Components/App/Locations/Add.js